import { call } from '@advanza/api'
import { Flag, Icon } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import TableList from 'components/TableList'
import SubscriptionsListContainer from 'containers/SubscriptionsListContainer'
import React from 'react'
import { Link } from 'react-router-dom'
import SetPrimarySubscriptionModal from './SetPrimarySubscriptionModal'

class SubscriptionList extends React.Component {
    definitions = {
        id: { name: '#' },
        active: { name: ' ' },
        service: { name: 'service' },
        name: { name: 'name' },
        coverage: { name: 'coverage' },
        primary: { name: ' ' },
        estimator: { name: '' },
    }

    constructor(props) {
        super(props)
        this.renderColumns = this.renderColumns.bind(this)
        this.renderRow = this.renderRow.bind(this)
        this.handleSetPrimaryClick = this.handleSetPrimaryClick.bind(this)
    }

    handleSetPrimaryClick(subscriptionId, event) {
        event.preventDefault()
        event.stopPropagation()

        const { provider, entities } = this.props
        if (provider) {
            const subscription = entities.subscriptions[subscriptionId]
            const serviceName = subscription?.serviceName || subscription?.name || 'Unknown Service'

            NiceModal.show(SetPrimarySubscriptionModal, {
                subscriptionId,
                serviceName,
                onCancel: () => {
                    // Handle cancel - nothing to do
                },
                onConfirm: async () => {
                    try {
                        await call(
                            `office/providers/update-primary-subscription/${provider.service_provider_id}`,
                            {
                                method: 'post',
                                body: JSON.stringify({ primary_subscription_id: subscriptionId }),
                            },
                        )

                        // Refresh the provider data to reflect the changes
                        // This will update the crown icons in the subscription list
                        window.location.reload()
                    } catch (error) {
                        console.error('Failed to update primary subscription:', error)
                    }
                },
            })
        }
    }

    renderColumns(id) {
        const { entities, provider } = this.props
        const { subscriptions } = entities
        const subscription = subscriptions[id]
        const title = subscription.name || subscription.serviceName || id

        const totalPopulation = subscription.country_code === 'BE' ? 11000000 : 17000000
        const coverage = subscription.use_municipalities
            ? Math.round((subscription.sumPopulation / totalPopulation) * 100)
            : subscription.coverage

        const coverageStyle = (percentage) => {
            return {
                color: `hsl(${percentage}, 100%, 40%, 1)`,
            }
        }

        const isPrimary = provider && provider.primary_subscription_id === parseInt(id)
        const isActive = subscription.active && !subscription.deleted

        // Render primary column content
        let primaryContent = <span />
        if (isPrimary) {
            primaryContent = (
                <Icon name="crown" style={{ color: '#FFD700' }} title="Primary subscription" />
            )
        } else if (isActive) {
            primaryContent = (
                <Icon
                    name="crown"
                    style={{ color: '#C0C0C0', cursor: 'pointer' }}
                    title="Click to set as primary subscription"
                    onClick={(e) => this.handleSetPrimaryClick(id, e)}
                />
            )
        }

        return [
            <small className="text">#{id}</small>,
            <Icon>
                {subscription.deleted
                    ? 'delete_forever'
                    : subscription.active
                      ? 'play_arrow'
                      : 'pause'}
            </Icon>,
            <>
                <Flag countryCode={subscription.country_code} /> {subscription.serviceName}
            </>,
            subscription.deleted ? <strike>{title}</strike> : title,
            <span style={coverageStyle(coverage)}>{coverage}%</span>,
            primaryContent,
            <Link
                title={
                    subscription?.subscriptions_expectation
                        ? JSON.stringify(subscription?.subscriptions_expectation, null, 2)
                        : 'Lead Estimator'
                }
                to={`/sales/lead-estimator?subscriptionId=${id}&serviceId=${subscription.service_id}&city=&previous=${window.location.pathname}`}>
                <Icon name="online_prediction" />
            </Link>,
        ]
    }

    renderRow(id) {
        return {
            url: `/service/providers/subscription/${id}`,
            cols: this.renderColumns(id),
            id,
        }
    }

    render() {
        const { selectable, ...rest } = this.props
        return (
            <TableList
                {...rest}
                selectable={selectable}
                renderRow={this.renderRow}
                definitions={this.definitions}
            />
        )
    }
}

SubscriptionList.propTypes = {}

export default SubscriptionsListContainer(SubscriptionList)
